import React from "react";
import Heading from "../Heading/Heading";
import "./GetInTouch.css";
import { MdLocationOn } from "react-icons/md";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";

export default function GetInTouch() {
  return (
    <div className="getintouch_section padding_top_bottom">
      <div className="container">
        <Heading MainHeader="GET IN TOUCH" />
        <div className="row section_align_items">
          <div className="getintouch_item layout-col-lg-6 layout-col-sm-12">
            <h1>Get in touch with us on the following contacts</h1>
            <p>
              <MdLocationOn />
              &nbsp; 11 Saise RD Rhodes Park Lusaka, Zambia
            </p>
            <p>
              <BsTelephoneFill />
              &nbsp; +260 964 810 627
            </p>
            <p>
              <MdEmail />
              &nbsp; elegroenergylimited@gmail.com
            </p>
          </div>
          <div className="getintouch_item layout-col-lg-6 layout-col-sm-12">
            <form
              method="POST"
              action="https://formsubmit.co/345be794ca153b23bfcd899c4cda8426"
            >
              <input type="hidden" name="_captcha" value="false"></input>
              <input type="hidden" name="_template" value="box"></input>
              <input
                type="hidden"
                name="_subject"
                value="A Mesaage from the Website:"
              ></input>
              <div>
                <input
                  type="text"
                  name="Full Names"
                  placeholder="Full Names"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  required
                />
              </div>
              <textarea
                rows="4"
                type="text"
                name="message"
                placeholder="Message"
                required
              ></textarea>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
